export const borders = {
  none: { value: 'none' },
}
